<template>
    <CardOption
        class="card-image"
        v-bind="{ card, questionnaireStore, isSelected }"
        @click.prevent.stop="$emit('toggle', !isSelected)"
    >
        <CmsImage
            :data="content.image"
            fit="cover"
        />
    </CardOption>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import type { QuestionnaireQuestionChoiceOptionContentImageFragment } from '@/graphql/api'
import type { QuestionnaireStore } from '@/components/cms/component/questionnaire/useQuestionnaireStore'
import { getOptionContent } from '../composables/evaluateConditions.ts'

import CardOption from './CardOption.vue'
import CmsImage from '@/components/cms/CmsImage.vue'

const props = defineProps<{
    card: QuestionnaireQuestionChoiceOptionContentImageFragment
    questionnaireStore: QuestionnaireStore
    isSelected: boolean | undefined
}>()

defineEmits<{
    'toggle': [select: boolean]
}>()

const route = useRoute()

const content = computed(() =>
    getOptionContent(
        props.card,
        props.questionnaireStore,
        route.params['id'] as string
    )
)
</script>
